export default __webpack_public_path__ + "static/media/soul.6cb655d9.png";